import type { RouteObject } from "react-router-dom";

const routes: RouteObject[] = [];

export default routes;
